import React, { useState } from 'react';

const LocationFetcher = ({ onLocationObtained }) => {
    const [status, setStatus] = useState("");

    const getLocation = () => {
        if (!navigator.geolocation) {
            setStatus("Geolocation not supported by your browser.");
            return;
        }

        setStatus("Locating...");

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                setStatus("✓");
                // Call the function passed via props with the location data
                onLocationObtained({ latitude, longitude });
            },
            (error) => {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        setStatus("You denied the request.");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        setStatus("Location information is unavailable.");
                        break;
                    case error.TIMEOUT:
                        setStatus("The request timed out.");
                        break;
                    default:
                        setStatus("An unknown error occurred.");
                        break;
                }
            }
        );
    };

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", textAlign:"center", justifyContent:"center", fontSize: "30px", paddingLeft: 0 }}>                       
            <button style={{ fontSize: "40px", borderWidth: 0, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }} onClick={getLocation}> Artists Near Me </button>
            <span style={{fontSize: "40px", paddingLeft:10, color:(status=="✓")? "darkgreen": "darkred"}}> {status} </span>
        </div>

    );
};

export default LocationFetcher;